module.exports = __webpack_public_path__ + "static/media/qclab-logo-white.931a24fd.svg";